// IconPam — símbolo minimalista da Pam (almoxarife).
// Cesta + ponto: representa estoque + atenção.
export default function IconPam({ size = 18, color = 'currentColor', filled = false }: {
  size?: number;
  color?: string;
  filled?: boolean;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      {/* Cesta/caixa minimalista — base larga + alça curva */}
      <path d="M4 10 L20 10" />
      <path d="M5 10 L7 18 A2 2 0 0 0 9 19 L15 19 A2 2 0 0 0 17 18 L19 10" />
      {/* Alça */}
      <path d="M8 10 A4 4 0 0 1 16 10" />
      {/* Ponto de atenção (alerta) */}
      <circle cx="12" cy="14.5" r="0.9" fill={color} stroke="none" />
    </svg>
  );
}
